module.exports = __webpack_public_path__ + "media/country_flags/cd-a5dfb083.png";